import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  return (
    <motion.section 
      className="hero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
    >
      <div className="hero-container">
        <motion.h1 
          className="hero-title"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Добро пожаловать в <span className="gradient-text">AirRoom Vape Shop</span>
        </motion.h1>
        <motion.p 
          className="hero-description"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          Широкий ассортимент премиальных жидкостей и одноразовых электронных сигарет. 
          Качество, которое вы заслуживаете.
        </motion.p>
      </div>
    </motion.section>
  );
};

export default Hero;

